if (!customElements.get('mobile-sticky-atc')) {
  customElements.define(
    'mobile-sticky-atc',
    class MobileStickyAtc extends HTMLElement {
      connectedCallback() {
        this.sectionId = this.dataset.sectionId;
        this.stickyButton = this.querySelector('[data-sticky-submit]');
        this.price = this.querySelector('[data-sticky-price]');
        this.variantTitle = this.querySelector('[data-sticky-variant]');
        this.variantAvailable = this.dataset.available === 'true';
        this.mainButtonVisible = true;
        this.hidden = false;

        this.handleClick = this.handleClick.bind(this);
        this.handleVariantChange = this.handleVariantChange.bind(this);
        this.stickyButton?.addEventListener('click', this.handleClick);

        if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
          this.variantChangeUnsubscriber = subscribe(PUB_SUB_EVENTS.variantChange, this.handleVariantChange);
        }

        this.observeMainButton();
        this.render();
      }

      disconnectedCallback() {
        this.stickyButton?.removeEventListener('click', this.handleClick);
        this.variantChangeUnsubscriber?.();
        this.mainButtonObserver?.disconnect();
      }

      get mainButton() {
        return document.getElementById(`ProductSubmitButton-${this.sectionId}`);
      }

      observeMainButton() {
        if (!this.mainButton) {
          this.mainButtonVisible = false;
          return;
        }

        this.mainButtonObserver = new IntersectionObserver(
          ([entry]) => {
            this.mainButtonVisible = entry.isIntersecting;
            this.render();
          },
          { threshold: 0.1 }
        );
        this.mainButtonObserver.observe(this.mainButton);
      }

      handleVariantChange({ data }) {
        if (String(data.sectionId) !== String(this.sectionId)) return;

        const { variant, html } = data;
        this.variantAvailable = Boolean(variant?.available);
        this.dataset.available = this.variantAvailable.toString();

        if (this.variantTitle && variant?.title) {
          this.variantTitle.textContent = variant.title;
        }

        const priceSource = html
          .getElementById(`price-${this.sectionId}`)
          ?.querySelector('.price--on-sale .price-item--sale, .price__regular .price-item--regular');
        if (this.price && priceSource) {
          this.price.textContent = priceSource.textContent.trim();
        }

        this.render();
      }

      handleClick() {
        const button = this.mainButton;
        if (!button || button.disabled || button.getAttribute('aria-disabled') === 'true') return;
        button.click();
      }

      render() {
        const mainButton = this.mainButton;
        const canSubmit = this.variantAvailable && mainButton && !mainButton.disabled;
        this.stickyButton.disabled = !canSubmit;
        this.classList.toggle('is-visible', canSubmit && !this.mainButtonVisible);
        this.setAttribute('aria-hidden', String(!canSubmit || this.mainButtonVisible));
        this.toggleAttribute('inert', !canSubmit || this.mainButtonVisible);
      }
    }
  );
}
